import React from "react";

const sizes = {
  xs: "320px",
  sm: "384px",
  md: "448px",
  lg: "512px",
  xl: "576px",
  "2xl": "672px",
  "3xl": "768px",
  "4xl": "896px",
  "5xl": "1024px",
  "6xl": "1152px",
  "7xl": "1280px",
  full: "98%"
};

export function Container({ children, maxWidth, styles, ...props }) {
  return (
    <section
      style={{
        maxWidth: sizes[maxWidth],
        padding: "0 1rem",
        marginInline: "auto",
        width: "100%",
        ...styles
      }}
      {...props}>
      {children}
    </section>
  );
}
